<template>
  <v-select
    :options="options"
    :selectName="selectName"
    :selectId="selectId"
    :value="modelValue"
    @input="$emit('update:modelValue', $event.target.value)"
    required
  ></v-select>
</template>

<script>
import VSelect from "@/components/ui/VSelect.vue";
import carFuelTypesApi from "../api/resources/carFuelTypesApi";

export default {
  props: {
    selectName: String,
    selectId: String,
    modelValue: [String, Number],
  },
  emits: ["update:modelValue"],
  components: { VSelect },

  data() {
    return {
      options: [],
    };
  },

  methods: {
    getCarMakes() {
      carFuelTypesApi.index().then((response) => {
        this.options = response.data.map((fuelType) => {
          return { text: fuelType.name, value: fuelType.id };
        });
      });
    },
  },

  created() {
    this.getCarMakes();
  },
};
</script>

<style></style>
